import React from "react";
import ReactLoading from "react-loading";

/**
 * NotificationDropdown — Bildirim açılır menüsü
 * NavbarMenu'dan çıkartıldı.
 */
const NotificationDropdown = ({
  notifications,
  toggleNotification,
  onToggle,
  onDeleteAll,
  onDelete,
  onDetailAndMarkAsRead,
  deleteAllNotifyLoading,
  deleteLoading,
}) => {
  return (
    <li className={toggleNotification ? "show dropdown" : "dropdown"} data-header-dropdown="notifications">
      <a
        href="#!"
        className="dropdown-toggle icon-menu"
        aria-label="Bildirimler"
        aria-expanded={toggleNotification}
        aria-haspopup="true"
        aria-controls="header-notifications"
        onClick={(e) => {
          e.preventDefault();
          onToggle();
        }}
      >
        <i className="icon-bell"></i>
        {notifications.length > 0 && notifications.some(n => n.is_read === 0) ? (
          <span className="font-weight-bolder text-cyan">
            {notifications.filter(n => n.is_read === 0).length}
          </span>
        ) : ""}
      </a>
      <ul
        id="header-notifications"
        hidden={!toggleNotification}
        className={
          toggleNotification
            ? "dropdown-menu notifications show"
            : "dropdown-menu notifications"
        }
        style={{ background: "white", maxHeight: "400px", overflowY: "auto", listStyle: "none" }}
      >
        {notifications.length > 0 ? (
          <>
            <li className="header" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              borderBottom: "1px solid #e0e0e0",
            }}>
              <strong>{notifications.filter(n => n.is_read === 0).length} Okunmamış Bildirim</strong>
              {deleteAllNotifyLoading ? (
                <ReactLoading type="spin" width="24px" height="24px" color="#268bd2" />
              ) : (
                <button onClick={onDeleteAll} className="btn btn-outline-danger" style={{ marginLeft: "auto" }}>
                  <i className="icon-trash"></i> Tümünü Sil
                </button>
              )}
            </li>
            {notifications.map((notification) => {
              const date = new Date(notification.created_at);
              const formattedDate = date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
              const formattedTime = date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
              const href = notification.type === 'stock_alert'
                ? `/stock/item-detail/${notification.stock_item_id}`
                : notification.type === 'einbox'
                  ? '/documents'
                  : (notification.type === 'einbox_confirmed' || notification.type === 'einbox_error')
                    ? `invoice/${notification.operation_id}/${notification.customer_id}`
                    : `/${notification.type === 'receivable' ? 'receivable' : 'offer'}-detail/${notification.data}`;
              const isLoading = deleteLoading[notification.id];
              const url = `${process.env.PUBLIC_URL}/invoice/${notification.operation_id}/${notification.customer_id}`;
              const currentHref = notification.type === 'einbox_error' || notification.type === 'einbox_confirm' ? url : href;
              const isStockAlert = notification.type === 'stock_alert';
              const stockAlertId = notification.stock_alert_id;

              return (
                <li key={notification.id} style={{ padding: "10px 5px", borderBottom: "1px solid #e0e0e0" }}>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      onDetailAndMarkAsRead(currentHref, notification.id, isStockAlert, stockAlertId);
                    }}
                    href="#!"
                    style={{ display: "block", textDecoration: "none" }}
                  >
                    <div className="media" style={{ display: "flex", alignItems: "flex-start" }}>
                      {/* Icon */}
                      <div className="media-left" style={{ paddingRight: "10px", flexShrink: 0 }}>
                        {notification.type === 'stock_alert' && (
                          <i className={`icon-layers ${notification.stock_alert_type === 'low_stock' ? 'text-warning' :
                            notification.stock_alert_type === 'out_of_stock' ? 'text-danger' : 'text-info'
                          }`} style={{ fontSize: "xx-large" }}></i>
                        )}
                        {notification.type === 'receivable' && (
                          <i className="icon-wallet text-warning" style={{ fontSize: "xx-large" }}></i>
                        )}
                        {notification.type === 'offer' && (
                          <i className="icon-envelope-letter text-info" style={{ fontSize: "xx-large" }}></i>
                        )}
                        {notification.type === 'servicezone' && (
                          <i className="icon-notification text-success" style={{ fontSize: "xx-large" }}></i>
                        )}
                        {notification.type === 'einbox' && (
                          <i className="icon-doc text-success" style={{ fontSize: "xx-large" }}></i>
                        )}
                        {notification.type === 'einbox_error' && (
                          <i className="icon-doc text-danger" style={{ fontSize: "xx-large" }}></i>
                        )}
                        {notification.type === 'einbox_confirmed' && (
                          <i className="icon-doc text-success" style={{ fontSize: "xx-large" }}></i>
                        )}
                      </div>

                      {/* Content */}
                      <div className="media-body" style={{ flex: 1 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap" }}>
                          <p className={`text ${notification.type === 'einbox_error' ? 'text-danger' : ''}`}
                            style={{ marginBottom: 0, wordWrap: "break-word", flex: "1 1 auto" }}>
                            {notification.message}
                          </p>
                          {isLoading ? (
                            <ReactLoading type="spin" width="24px" height="24px" color="#268bd2" />
                          ) : (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                onDelete(notification.id, isStockAlert, stockAlertId);
                              }}
                              className="btn btn-outline-danger p-1 ml-2"
                              style={{ flexShrink: 0 }}
                            >
                              <i className="icon-trash" style={{ fontSize: "small" }}></i>
                            </button>
                          )}
                        </div>
                        <span className="timestamp" style={{ fontSize: "small", color: "#888" }}>
                          {formattedDate} {formattedTime}
                        </span><br />
                        <small className={`${notification.is_read === 0 ? "text-danger" : "text-success"}`}>
                          {notification.is_read === 0 ? " (Okunmadı)" : " (Okundu)"}
                        </small>
                      </div>
                    </div>
                  </a>
                </li>
              );
            })}
          </>
        ) : (
          <li>
            <div className="text-center">
              <i className="icon-info text-danger"></i>
              <p>Yeni bildirim yok.</p>
            </div>
          </li>
        )}
      </ul>
    </li>
  );
};

export default NotificationDropdown;
